




















import mixins from 'vue-typed-mixins'
import VisibleColumns from '@/abstract/VisibleColumns'
import PaidLabel from '@/components/PaidLabel/PaidLabel.vue'
import DataTable from '@/components/DataTable/DataTable.vue'
import DataTableTop from '@/components/DataTable/DataTableTop.vue'
import iconDownload from '@/assets/svg/rounded/download.svg?inline'
import { mapGetters } from 'vuex'
import BaseLayout from '@/layout/BaseLayout.vue'
import store from '@/store'
import { DataTableResponse } from '@/models/scripts'
import { DataTablePayload, TableSetting } from '@/models/dataTable'
import { RecordingsActionTypes } from '@/store/modules/recordings/actions'
import { WATCHED_QUERY, ETableView } from '@/constants/dataTable'
import { ItemsForDownload } from '@/models/dataTable'
import { localStorageSet, localStorageGet } from '@/helpers/localStorage'
import { Company } from '@/models/companies'
import { UserFull } from '@/models/users'

interface Methods {
  getRecording: () => Promise<void>
  getFile: () => Promise<void>
  prepRecordingRequest: (query: { [key: string]: string }) => void
  saveQuery: () => void
  localStorageHandler: () => void
}

interface Data {
  param: DataTablePayload
  tableSetting: TableSetting
  itemsForDownload: ItemsForDownload
}

interface Computed {
  getMe: UserFull
  recordings: DataTableResponse
  tableData: DataTableResponse
  queryString: string
  downloadLink: string
  disableDownloadBtn: boolean
  activeCompany: Company | undefined
}

export default mixins(VisibleColumns).extend<Data, Methods, Computed, {}>({
  components: {
    BaseLayout,
    PaidLabel,
    DataTable,
    iconDownload,
    DataTableTop,
  },
  data() {
    return {
      param: {
        limit: 20,
        offset: 0,
        expand: '',
        filter: '',
        sort: '',
      },
      tableSetting: {
        enableFilters: true,
        enableRowInfo: true,
        directory: 'Records',
        showLoader: false,
        enableChecking: true,
        view: ETableView.table,
      },
      itemsForDownload: {
        id: [],
        exept: false,
      },
    }
  },
  computed: {
    ...mapGetters({
      recordings: 'getRecordings',
      downloadLink: 'getDownloadLink',
      activeCompany: 'getActiveCompany',
      getMe: 'getMe',
    }),
    tableData() {
      const columns = this.$route.query.columns
      const data: DataTableResponse = Object.assign({}, this.recordings)
      if (
        data.columns &&
        data.columns.length > 0 &&
        typeof columns === 'string' &&
        !columns.split(',').includes('id')
      ) {
        data.columns = data.columns.map(elem => {
          if (
            !this.isVisibleColumn(this.tableSetting.directory, elem.key) ||
            elem.key === 'id'
          ) {
            return { ...elem, visible: false }
          } else {
            return elem
          }
        })
      }
      return data
    },
    queryString() {
      return JSON.stringify(this.$route.query)
    },
    disableDownloadBtn() {
      if (
        (this.itemsForDownload.id.length === 0 &&
          !this.itemsForDownload.exept) ||
        (this.itemsForDownload.id.length === this.recordings.pagination.total &&
          this.itemsForDownload.exept)
      ) {
        return true
      }
      return false
    },
  },
  methods: {
    async getRecording() {
      this.tableSetting.showLoader = true
      await store.dispatch(RecordingsActionTypes.Load, this.param)
      this.tableSetting.showLoader = false
    },
    async getFile() {
      await store.dispatch(
        RecordingsActionTypes.Download,
        this.itemsForDownload,
      )
      window.open(this.downloadLink)
    },
    prepRecordingRequest(query) {
      this.param.limit = Number(query.limit) || 20
      this.param.offset = Number(query.offset) || 0
      this.param.expand = query.columns || ''
      this.param.sort = query.sort || ''
      this.param.filter = query.filter || ''
      this.getRecording()
    },
    saveQuery() {
      if (this.activeCompany) {
        localStorageSet(
          `datatable_records_query_${this.activeCompany.id}`,
          this.queryString,
        )
      }
    },
    localStorageHandler() {
      try {
        if (
          this.activeCompany &&
          localStorageGet(
            `datatable_records_query_${this.activeCompany.id}`,
          ) !== '{}' &&
          JSON.parse(
            localStorageGet(`datatable_records_query_${this.activeCompany.id}`),
          ) !== this.$route.query &&
          this.queryString === '{}'
        ) {
          this.$router.push({
            query: JSON.parse(
              localStorageGet(
                `datatable_records_query_${this.activeCompany.id}`,
              ),
            ),
          })
        }
      } catch {
        this.saveQuery()
      }
      this.prepRecordingRequest(this.$route.query as { [key: string]: string })
    },
  },
  watch: {
    '$route.query'(newQuery, oldQuery) {
      this.saveQuery()
      WATCHED_QUERY.forEach(elem => {
        if (newQuery[elem] !== oldQuery[elem]) {
          this.prepRecordingRequest(newQuery)
        }
      })
    },
    activeCompany() {
      if (this.$route.query) {
        this.$router.replace({ query: {} })
      }
      this.localStorageHandler()
    },
    '$route.query.view'(view) {
      if (view) {
        return (this.tableSetting.view = view)
      }
      this.tableSetting.view = ETableView.table
    },
  },
  mounted() {
    if (this.$route.query.view === ETableView.kanban) {
      this.tableSetting.showLoader = false
    }
    this.tableSetting.view =
      (this.$route.query.view as ETableView) || ETableView.table
    this.localStorageHandler()
  },
  metaInfo() {
    return { title: this.$tc('records.records') }
  },
})
